<div
  class="breadcrumb-title"
  fxLayout="row"
  fxLayoutAlign="space-between center"
>
  <ul class="breadcrumb" *ngIf="visibleBreadcrumbs.length > 0">
    <li *ngFor="let breadcrumb of visibleBreadcrumbs; last as isLast">
      <a [routerLink]="breadcrumb.url" *ngIf="breadcrumb.url">{{
        breadcrumb.text | translate
      }}</a>
      <span *ngIf="!breadcrumb.url">{{ breadcrumb.text | translate }}</span>
    </li>
  </ul>

  <ng-content></ng-content>
</div>
